import { render, staticRenderFns } from "./Livebook.vue?vue&type=template&id=5d5222b5"
import script from "./Livebook.vue?vue&type=script&lang=js"
export * from "./Livebook.vue?vue&type=script&lang=js"
import style0 from "./Livebook.vue?vue&type=style&index=0&id=5d5222b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports